import ArgonBox from "components/ArgonBox";
import React, { useEffect, useState } from "react";
import { Grid, Card, Avatar, Chip, Autocomplete, TextField } from "@mui/material";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PersonIcon from "@mui/icons-material/Person";
import CancelIcon from "@mui/icons-material/Cancel";
import Table from "examples/Tables/Table";
import ParentsProfileTableData from "./data/parentProfileTableData";
import ArgonButton from "components/ArgonButton";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from "@mui/material";
import DeleteDialog from "components/DeleteDialog/DeleteDialog";
import CloseIcon from "@mui/icons-material/Close";
import ArgonInput from "components/ArgonInput";
import { Link, useParams } from "react-router-dom";
import axios from "utils/api";
import { baseURL } from "utils/api";
import { toast } from "react-toastify";
import { Box } from "@mui/material";
import FileUploader from "components/FileUploader/FileUploader";
import { CircularProgress } from "@mui/material";
import Dropdown from "components/CustomDropdown/Dropdown";

function profile() {
  const { columns, rows } = ParentsProfileTableData;

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const [showAllNotesOpen, setShowAllNotesOpen] = useState(false);
  const [noteInput, setNoteInput] = useState("");
  const [savingNote, setSavingNote] = useState(false);
  const [parentNotes, setParentNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);

  const [editOpen, setEditOpen] = useState(false);
  const handleEditOpen = () => setEditOpen(true);
  const handleEditClose = () => setEditOpen(false);

  const { id } = useParams();
  console.log(id);

  const [parent, setParent] = useState([]);
  const [students, setStudents] = useState([]);
  const [studentTableRows, setStudentTableRows] = useState([]);

  // Class Sessions State
  const [classSessions, setClassSessions] = useState([]);
  const [classTableRows, setClassTableRows] = useState([]);
  const [classTableColumns, setClassTableColumns] = useState([
    { name: "sno", align: "center" },
    { name: "Tutor Name", align: "left" },
    { name: "Student Name", align: "left" },
    { name: "Class/Board", align: "left" },
    { name: "Subjects", align: "left" },
    { name: "Session Type", align: "center" },
  ]);

  // helper to safely render values (handles objects like { _id, name })
  const displayValue = (val, fallback = "NA") => {
    if (val === null || val === undefined || val === "") return fallback;
    if (typeof val === "object") {
      if (Array.isArray(val)) {
        return val
          .map((v) =>
            v && typeof v === "object" ? v.name || v.title || v._id || JSON.stringify(v) : v
          )
          .join(", ");
      }
      return val.name || val.title || val.boardName || val._id || fallback;
    }
    return val;
  };

  // Edit form states
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [alternatePhone, setAlternatePhone] = useState("");
  const [address, setAddress] = useState("");
  const [profileImageFiles, setProfileImageFiles] = useState([]);
  const [profileImagePreview, setProfileImagePreview] = useState("");
  const [updating, setUpdating] = useState(false);

  // Image Modal States
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Student Edit States
  const [studentAddOpen, setStudentAddOpen] = useState(false);
  const [studentEditOpen, setStudentEditOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [studentName, setStudentName] = useState("");
  const [studentGender, setStudentGender] = useState("");
  const [studentDob, setStudentDob] = useState("");
  const [studentSchoolName, setStudentSchoolName] = useState("");
  const [studentPreferredTime, setStudentPreferredTime] = useState("");
  const [studentClassesPerWeek, setStudentClassesPerWeek] = useState("");
  const [studentModeOfTuition, setStudentModeOfTuition] = useState("");
  const [studentClass, setStudentClass] = useState("");
  const [studentBoard, setStudentBoard] = useState("");
  const [studentSubjects, setStudentSubjects] = useState([]);
  const [studentTuitionPreferredLocation, setStudentTuitionPreferredLocation] = useState("");
  const [creatingStudent, setCreatingStudent] = useState(false);
  const [updatingStudent, setUpdatingStudent] = useState(false);

  // Dropdown data for class, board, subjects
  const [allClasses, setAllClasses] = useState([]);
  const [allBoards, setAllBoards] = useState([]);
  const [allSubjects, setAllSubjects] = useState([]);

  // Student delete states
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [studentToDelete, setStudentToDelete] = useState(null);

  useEffect(() => {
    // Fetch parent details
    axios
      .get(`${baseURL}/parent/profile/${id}`)
      .then((res) => {
        console.log("parent data", res.data);
        if (res.data.success) {
          const parentData = res.data.data;
          setParent(parentData);

          // Populate edit form
          setFullName(parentData.fullName || "");
          setEmail(parentData.email || "");
          setPhone(parentData.phone || "");
          setAlternatePhone(parentData.alternatePhone || "");
          setAddress(parentData.address || "");
          setProfileImagePreview(parentData.profileImage || "");
        }
      })
      .catch((err) => {
        console.log(err);
      });

    // Fetch students by parent id
    axios
      .get(`${baseURL}/student?parentId=${id}`)
      .then((res) => {
        console.log("students by parent id", res.data);
        if (res.data.success && res.data.data.length > 0) {
          setStudents(res.data.data);
          // API data ko table rows me map karna
          const rows = res.data.data.map((student, index) => ({
            sno: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {index + 1}
              </ArgonTypography>
            ),
            "student Name": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.name || "NA"}
              </ArgonTypography>
            ),

            Gender: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.gender || "NA"}
              </ArgonTypography>
            ),
            "Date of Birth": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {new Date(student.dob).toLocaleDateString() || "NA"}
              </ArgonTypography>
            ),
            "School/College/University Name": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.schoolName || "NA"}
              </ArgonTypography>
            ),
            Class: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {[
                  displayValue(student.class || student.standard || student.currentClass, ""),
                  displayValue(student.board || student.educationBoard || student.boardName, ""),
                  student.subjects && student.subjects.length > 0
                    ? student.subjects.map((s) => (s && s.name) || s).join(", ")
                    : student.subject
                    ? displayValue(student.subject, "")
                    : "",
                ]
                  .filter(Boolean)
                  .join(" | ") || "NA"}
              </ArgonTypography>
            ),
            "Preferred Time Duration": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.preferredTimeDuration || "NA"} mins
              </ArgonTypography>
            ),
            "Tuition Tenure": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.noOfClassesPerWeek || "NA"} classes/week
              </ArgonTypography>
            ),
            "mode Of Tuition": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.modeOfTuition || "NA"}
              </ArgonTypography>
            ),
            "Tuition Preferred Location": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {displayValue(student.tutionPreferedLocation) || "NA"}
              </ArgonTypography>
            ),
            Action: (
              <ArgonBox display="flex" gap={1}>
                <IconButton
                  onClick={() => handleStudentEditOpen(student)}
                  size="small"
                  sx={{
                    color: "#667eea",
                    "&:hover": { backgroundColor: "rgba(102, 126, 234, 0.1)" },
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>

                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    console.log("delete button clicked", student?._id);
                    handleStudentDeleteOpen(student);
                  }}
                  size="small"
                  sx={{
                    color: "#ff4d4f",
                    "&:hover": { backgroundColor: "rgba(255, 77, 79, 0.08)" },
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </ArgonBox>
            ),
            // "Tutors Level": (
            //   <ArgonTypography variant="caption" color="text" fontWeight="medium">
            //     {student.currentSubscription?.tutorAccess || "N/A"}
            //   </ArgonTypography>
            // ),
          }));
          setStudentTableRows(rows);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  useEffect(() => {
    const fetchParentNotes = async () => {
      if (!id) return;
      try {
        setNotesLoading(true);
        const res = await axios.get(`/parent/${id}/notes`);
        if (res.data?.success) {
          setParentNotes(Array.isArray(res.data.data) ? res.data.data : []);
        } else {
          setParentNotes([]);
        }
      } catch (err) {
        console.error("Error fetching parent notes:", err);
        setParentNotes([]);
      } finally {
        setNotesLoading(false);
      }
    };

    fetchParentNotes();
  }, [id]);

  const handleOpenNoteDialog = () => {
    setNoteInput("");
    setOpen(true);
  };

  const handleOpenShowAllNotes = () => {
    setShowAllNotesOpen(true);
  };

  const handleCloseShowAllNotes = () => {
    setShowAllNotesOpen(false);
  };

  const handleSaveNote = async (e) => {
    if (e) e.preventDefault();
    if (!id) {
      toast.error("Parent ID is missing");
      return;
    }

    if (!noteInput.trim()) {
      toast.error("Please enter a note");
      return;
    }

    try {
      setSavingNote(true);
      const res = await axios.post(`/parent/${id}/notes`, {
        note: noteInput.trim(),
      });

      if (res.data?.success) {
        toast.success("Note added successfully");
        setOpen(false);
        setNoteInput("");
        const refreshed = await axios.get(`/parent/${id}/notes`);
        if (refreshed.data?.success) {
          setParentNotes(Array.isArray(refreshed.data.data) ? refreshed.data.data : []);
        }
      } else {
        throw new Error(res.data?.message || "Failed to add note");
      }
    } catch (err) {
      console.error("Error adding note:", err);
      toast.error(err.response?.data?.message || err.message || "Failed to add note");
    } finally {
      setSavingNote(false);
    }
  };

  // Fetch classes for dropdown
  useEffect(() => {
    axios
      .get(`${baseURL}/classes?limit=100`)
      .then((res) => {
        if (res.data.success) {
          const activeClasses = (res.data.data || []).filter((cls) => !cls.isDeleted);
          const options = activeClasses.map((cls) => ({ label: cls.name, value: cls._id, ...cls }));
          setAllClasses(options);
        }
      })
      .catch((err) => console.error("Error fetching classes:", err));
  }, []);

  // Fetch boards for dropdown
  useEffect(() => {
    axios
      .get(`${baseURL}/boards?limit=100`)
      .then((res) => {
        if (res.data.success) {
          const activeBoards = (res.data.data || []).filter((board) => !board.isDeleted);
          const options = activeBoards.map((board) => ({
            label: board.name,
            value: board._id,
            ...board,
          }));
          setAllBoards(options);
        }
      })
      .catch((err) => console.error("Error fetching boards:", err));
  }, []);

  // Fetch subjects for dropdown
  useEffect(() => {
    axios
      .get(`${baseURL}/subjects?limit=500`)
      .then((res) => {
        if (res.data.success) {
          const options = res.data.data.map((subj) => ({
            label: subj.name,
            value: subj._id,
            ...subj,
          }));
          setAllSubjects(options);
        }
      })
      .catch((err) => console.error("Error fetching subjects:", err));
  }, []);

  // Fetch class sessions (Classes Assigned to)
  useEffect(() => {
    if (!id) return;

    axios
      .get(`${baseURL}/classes/parent/${id}/accept-tutor?status=ACTIVE&limit=100`)
      .then((res) => {
        console.log("class sessions data", res.data);
        if (res.data.success && res.data.data) {
          const filteredSessions = res.data.data.filter((session) => {
            const isCompletedDemo =
              session.sessionType === "DEMO" &&
              ["DONE", "COMPLETED"].includes((session.demoStatus || "").toUpperCase());

            return !isCompletedDemo;
          });

          setClassSessions(filteredSessions);

          // Map API data to table rows
          const rows = filteredSessions.map((session, index) => {
            const studentNames = session.students?.map((s) => s.name).join(", ") || "NA";
            const tutorName = session.tutor?.name || session.tutor?.fullName || "NA";
            const tutorProfileId = session.tutor?._id || session.tutor?.id;
            const classBoard =
              [session.students?.[0]?.class || "", session.students?.[0]?.board || ""]
                .filter(Boolean)
                .join(" / ") || "NA";
            const subjects = session.students?.[0]?.subjects?.join(", ") || "NA";
            const sessionType =
              session.sessionType === "DEMO"
                ? "Demo Class"
                : session.sessionType === "REGULAR_CLASS"
                ? "Regular Class"
                : "NA";

            return {
              sno: (
                <ArgonTypography variant="caption" color="text" fontWeight="medium">
                  {index + 1}
                </ArgonTypography>
              ),
              "Tutor Name": (
                <ArgonTypography
                  variant="caption"
                  color={tutorProfileId ? "primary" : "text"}
                  fontWeight="medium"
                  component={tutorProfileId ? Link : "span"}
                  to={tutorProfileId ? `/tutors/profile/${tutorProfileId}` : undefined}
                  sx={{
                    cursor: tutorProfileId ? "pointer" : "default",
                    textDecoration: tutorProfileId ? "underline !important" : "none",
                    textUnderlineOffset: tutorProfileId ? "2px" : undefined,
                    textDecorationThickness: tutorProfileId ? "1px" : undefined,
                    "&:hover": tutorProfileId
                      ? {
                          color: "#1976d2",
                          textDecoration: "underline !important",
                        }
                      : {},
                  }}
                >
                  {tutorName}
                </ArgonTypography>
              ),
              "Student Name": (
                <ArgonTypography variant="caption" color="text" fontWeight="medium">
                  {studentNames}
                </ArgonTypography>
              ),
              "Class/Board": (
                <ArgonTypography variant="caption" color="text" fontWeight="medium">
                  {classBoard}
                </ArgonTypography>
              ),
              Subjects: (
                <ArgonTypography variant="caption" color="text" fontWeight="medium">
                  {subjects}
                </ArgonTypography>
              ),
              "Session Type": (
                <ArgonTypography variant="caption" color="text" fontWeight="medium">
                  {sessionType}
                </ArgonTypography>
              ),
            };
          });

          setClassTableRows(rows);
        }
      })
      .catch((err) => {
        console.error("Error fetching class sessions:", err);
        setClassTableRows([]);
      });
  }, [id]);

  console.log("parents data", parent);
  console.log(students);

  const resetStudentForm = () => {
    setStudentName("");
    setStudentGender("");
    setStudentDob("");
    setStudentSchoolName("");
    setStudentPreferredTime("");
    setStudentClassesPerWeek("");
    setStudentModeOfTuition("");
    setStudentClass("");
    setStudentBoard("");
    setStudentSubjects([]);
    setStudentTuitionPreferredLocation("");
  };

  const handleStudentAddOpen = () => {
    setSelectedStudent(null);
    resetStudentForm();
    setStudentAddOpen(true);
  };

  const handleStudentAddClose = () => {
    setStudentAddOpen(false);
    resetStudentForm();
  };

  // Handle student edit open
  const handleStudentEditOpen = (student) => {
    setSelectedStudent(student);
    setStudentName(student.name || "");
    setStudentGender(student.gender || "");
    setStudentDob(student.dob ? new Date(student.dob).toISOString().split("T")[0] : "");
    setStudentSchoolName(student.schoolName || "");
    setStudentPreferredTime(student.preferredTimeDuration || "");
    setStudentClassesPerWeek(student.noOfClassesPerWeek || "");
    setStudentModeOfTuition(student.modeOfTuition || "");
    setStudentTuitionPreferredLocation(student.tutionPreferedLocation || "");

    // Set class, board, and subjects
    setStudentClass(student.class?._id || student.class || "");
    setStudentBoard(student.board?._id || student.board || "");

    // Handle subjects array - could be objects or IDs
    const subjectIds = student.subjects ? student.subjects.map((s) => s._id || s) : [];
    setStudentSubjects(subjectIds);

    setStudentEditOpen(true);
  };

  const handleStudentEditClose = () => {
    setStudentEditOpen(false);
    setSelectedStudent(null);
    resetStudentForm();
  };

  // Delete handlers
  const handleStudentDeleteOpen = (student) => {
    console.log("handleStudentDeleteOpen called", student?._id);
    setStudentToDelete(student);
    // small delay to avoid any event loop conflicts
    setTimeout(() => setDeleteDialogOpen(true), 0);
  };

  const handleStudentDeleteClose = () => {
    setStudentToDelete(null);
    setDeleteDialogOpen(false);
  };

  const handleStudentDeleteConfirm = async () => {
    if (!studentToDelete?._id) return;
    try {
      const res = await axios.delete(`${baseURL}/student/${studentToDelete._id}`);
      if (res.data.success) {
        toast.success(res.data.message || "Student deleted successfully");
        // refresh students
        const refreshRes = await axios.get(`${baseURL}/student?parentId=${id}`);
        if (refreshRes.data.success) {
          setStudents(refreshRes.data.data || []);
          const rows = refreshRes.data.data.map((student, index) => ({
            sno: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {index + 1}
              </ArgonTypography>
            ),
            "student Name": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.name || "NA"}
              </ArgonTypography>
            ),
            Gender: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.gender || "NA"}
              </ArgonTypography>
            ),
            "Date of Birth": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {new Date(student.dob).toLocaleDateString() || "NA"}
              </ArgonTypography>
            ),
            "School/College/University Name": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.schoolName || "NA"}
              </ArgonTypography>
            ),
            Class: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {[
                  displayValue(student.class || student.standard || student.currentClass, ""),
                  displayValue(student.board || student.educationBoard || student.boardName, ""),
                  student.subjects && student.subjects.length > 0
                    ? student.subjects.map((s) => (s && s.name) || s).join(", ")
                    : student.subject
                    ? displayValue(student.subject, "")
                    : "",
                ]
                  .filter(Boolean)
                  .join(" | ") || "NA"}
              </ArgonTypography>
            ),
            "Preferred Time Duration": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.preferredTimeDuration || "NA"} mins
              </ArgonTypography>
            ),
            "Tuition Tenure": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.noOfClassesPerWeek || "NA"} classes/week
              </ArgonTypography>
            ),
            "mode Of Tuition": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.modeOfTuition || "NA"}
              </ArgonTypography>
            ),
            "Tuition Preferred Location": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {displayValue(student.tutionPreferedLocation) || "NA"}
              </ArgonTypography>
            ),
            Action: (
              <ArgonBox display="flex" gap={1}>
                <IconButton
                  onClick={() => handleStudentEditOpen(student)}
                  size="small"
                  sx={{
                    color: "#667eea",
                    "&:hover": { backgroundColor: "rgba(102, 126, 234, 0.1)" },
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>

                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    console.log("delete button clicked", student?._id);
                    handleStudentDeleteOpen(student);
                  }}
                  size="small"
                  sx={{
                    color: "#ff4d4f",
                    "&:hover": { backgroundColor: "rgba(255, 77, 79, 0.08)" },
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </ArgonBox>
            ),
          }));
          setStudentTableRows(rows);
        }
      } else {
        toast.error(res.data.msg || "Failed to delete student");
      }
    } catch (err) {
      console.error("Error deleting student:", err);
      toast.error(err.response?.data?.msg || "Failed to delete student");
    } finally {
      handleStudentDeleteClose();
    }
  };

  // Debug: log when delete dialog state changes
  React.useEffect(() => {
    console.log("deleteDialogOpen", deleteDialogOpen, "studentToDelete", studentToDelete?._id);
  }, [deleteDialogOpen, studentToDelete]);

  const handleCreateStudent = async (e) => {
    e.preventDefault();

    if (!studentName.trim()) {
      toast.error("Please enter student name");
      return;
    }

    setCreatingStudent(true);

    try {
      const createData = {
        parentId: id,
        name: studentName.trim(),
        gender: studentGender || undefined,
        dob: studentDob || undefined,
        schoolName: studentSchoolName,
        preferredTimeDuration: studentPreferredTime || undefined,
        noOfClassesPerWeek: studentClassesPerWeek || undefined,
        modeOfTuition: studentModeOfTuition || undefined,
        tutionPreferedLocation: studentTuitionPreferredLocation || undefined,
        class: studentClass || undefined,
        board: studentBoard || undefined,
        subjects: studentSubjects && studentSubjects.length > 0 ? studentSubjects : undefined,
      };

      const response = await axios.post(`${baseURL}/student`, createData);

      if (response.data.success) {
        toast.success("Student added successfully");
        handleStudentAddClose();

        const refreshRes = await axios.get(`${baseURL}/student?parentId=${id}`);
        if (refreshRes.data.success) {
          setStudents(refreshRes.data.data || []);
          const tableData = ParentsProfileTableData(
            refreshRes.data.data || [],
            handleStudentEditOpen,
            handleStudentDeleteOpen
          );
          setStudentTableRows(tableData.rows || []);
        }
      } else {
        toast.error(response.data.msg || response.data.message || "Failed to add student");
      }
    } catch (error) {
      console.error("Error adding student:", error);
      toast.error(
        error.response?.data?.message || error.response?.data?.msg || "Failed to add student"
      );
    } finally {
      setCreatingStudent(false);
    }
  };
  // Handle student update
  const handleUpdateStudent = async (e) => {
    e.preventDefault();
    setUpdatingStudent(true);

    try {
      const updateData = {
        name: studentName,
        gender: studentGender,
        dob: studentDob || undefined,
        schoolName: studentSchoolName,
        preferredTimeDuration: studentPreferredTime,
        noOfClassesPerWeek: studentClassesPerWeek,
        modeOfTuition: studentModeOfTuition,
        tutionPreferedLocation: studentTuitionPreferredLocation || undefined,
        class: studentClass || undefined,
        board: studentBoard || undefined,
        subjects: studentSubjects && studentSubjects.length > 0 ? studentSubjects : undefined,
      };

      const response = await axios.put(`${baseURL}/student/${selectedStudent._id}`, updateData);

      if (response.data.success) {
        toast.success("Student details updated successfully");
        handleStudentEditClose();

        // Refresh students list
        const refreshRes = await axios.get(`${baseURL}/student?parentId=${id}`);
        if (refreshRes.data.success && refreshRes.data.data.length > 0) {
          setStudents(refreshRes.data.data);
          const rows = refreshRes.data.data.map((student, index) => ({
            sno: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {index + 1}
              </ArgonTypography>
            ),
            "student Name": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.name || "NA"}
              </ArgonTypography>
            ),
            Gender: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.gender || "NA"}
              </ArgonTypography>
            ),
            "Date of Birth": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {new Date(student.dob).toLocaleDateString() || "NA"}
              </ArgonTypography>
            ),
            "School/College/University Name": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.schoolName || "NA"}
              </ArgonTypography>
            ),
            "Class Name": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {[
                  displayValue(student.class || student.standard || student.currentClass, ""),
                  displayValue(student.board || student.educationBoard || student.boardName, ""),
                  student.subjects && student.subjects.length > 0
                    ? student.subjects.map((s) => (s && s.name) || s).join(", ")
                    : student.subject
                    ? displayValue(student.subject, "")
                    : "",
                ]
                  .filter(Boolean)
                  .join(" | ") || "NA"}
              </ArgonTypography>
            ),
            "Preferred Time Duration": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.preferredTimeDuration || "NA"} mins
              </ArgonTypography>
            ),
            "Tuition Tenure": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.noOfClassesPerWeek || "NA"} classes/week
              </ArgonTypography>
            ),
            "mode Of Tuition": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {student.modeOfTuition || "NA"}
              </ArgonTypography>
            ),
            "Tuition Preferred Location": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {displayValue(student.tutionPreferedLocation) || "NA"}
              </ArgonTypography>
            ),
            Action: (
              <ArgonBox display="flex" gap={1}>
                <IconButton
                  onClick={() => handleStudentEditOpen(student)}
                  size="small"
                  sx={{
                    color: "#667eea",
                    "&:hover": { backgroundColor: "rgba(102, 126, 234, 0.1)" },
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>

                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    console.log("delete button clicked", student?._id);
                    handleStudentDeleteOpen(student);
                  }}
                  size="small"
                  sx={{
                    color: "#ff4d4f",
                    "&:hover": { backgroundColor: "rgba(255, 77, 79, 0.08)" },
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </ArgonBox>
            ),
          }));
          setStudentTableRows(rows);
        }
      } else {
        toast.error(response.data.msg || "Failed to update student details");
      }
    } catch (error) {
      console.error("Error updating student:", error);
      toast.error(error.response?.data?.msg || "Failed to update student details");
    } finally {
      setUpdatingStudent(false);
    }
  };

  // Handle parent profile update
  const handleUpdateParent = async (e) => {
    e.preventDefault();
    setUpdating(true);

    try {
      // Validate phone numbers
      if (phone && phone.toString().length !== 10) {
        toast.error("Phone number must be exactly 10 digits");
        setUpdating(false);
        return;
      }

      if (alternatePhone && alternatePhone.toString().length !== 10) {
        toast.error("Alternate phone number must be exactly 10 digits");
        setUpdating(false);
        return;
      }

      const formData = new FormData();

      formData.append("fullName", fullName);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("alternatePhone", alternatePhone);
      formData.append("address", address);

      // Add profile image if new file selected
      if (profileImageFiles.length > 0) {
        const fileToUpload = profileImageFiles[0].file || profileImageFiles[0];
        formData.append("profileImage", fileToUpload);
      } else {
        console.log("❌ No file selected");
      }

      const response = await axios.put(`${baseURL}/parent/profile/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.success) {
        toast.success("Parent profile updated successfully");
        setParent(response.data.data);
        handleEditClose();

        // Refresh parent data
        const refreshRes = await axios.get(`${baseURL}/parent/profile/${id}`);
        if (refreshRes.data.success) {
          setParent(refreshRes.data.data);
        }
      } else {
        toast.error(response.data.msg || "Failed to update parent profile");
      }
    } catch (error) {
      console.error("Error updating parent:", error);
      toast.error(error.response?.data?.msg || "Failed to update parent profile");
    } finally {
      setUpdating(false);
    }
  };

  return (
    <ArgonBox mt={4}>
      {/* Profile Header with Purple Gradient */}
      <Grid container mt={2} spacing={2}>
        <Grid item xs={12}>
          <Card
            sx={{
              borderRadius: 2,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              p: 2,
            }}
          >
            <ArgonBox display="flex" alignItems="center" justifyContent="space-between">
              <ArgonBox display="flex" alignItems="center" gap={2}>
                <Avatar
                  src={parent?.profileImage || ""}
                  alt={parent?.fullName || "Parent Image"}
                  onClick={() => {
                    if (parent?.profileImage) {
                      setSelectedImage(parent?.profileImage);
                      setImageModalOpen(true);
                    } else {
                      toast.info("No profile image available");
                    }
                  }}
                  sx={{
                    width: 70,
                    height: 70,
                    border: "3px solid white",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                    cursor: "pointer",
                  }}
                />
                <ArgonBox>
                  <ArgonTypography variant="h5" fontWeight="bold" color="white" mb={1}>
                    {parent?.fullName}
                  </ArgonTypography>
                  <ArgonBox display="flex" flexDirection="column" gap={0.5}>
                    <ArgonBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
                      <ArgonBox
                        sx={{
                          backgroundColor: "rgba(255,255,255,0.2)",
                          borderRadius: "8px",
                          padding: "4px 12px",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <ArgonTypography variant="caption" color="white" fontWeight="bold">
                          📞
                        </ArgonTypography>
                        <ArgonTypography variant="caption" color="white" fontWeight="medium">
                          {parent?.phone || "N/A"}
                        </ArgonTypography>
                      </ArgonBox>
                      {parent?.alternatePhone && (
                        <ArgonBox
                          sx={{
                            backgroundColor: "rgba(255,255,255,0.2)",
                            borderRadius: "8px",
                            padding: "4px 12px",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <PhoneAndroidIcon
                            htmlColor="#ffffff"
                            sx={{
                              color: "#ffffff !important",
                              fill: "#ffffff",
                              fontSize: "16px !important",
                            }}
                          />

                          <ArgonTypography variant="caption" color="white" fontWeight="medium">
                            {parent.alternatePhone}
                          </ArgonTypography>
                        </ArgonBox>
                      )}
                      <ArgonBox
                        sx={{
                          backgroundColor: "rgba(255,255,255,0.2)",
                          borderRadius: "8px",
                          padding: "4px 12px",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <ArgonTypography variant="caption" color="white" fontWeight="bold">
                          ✉️
                        </ArgonTypography>
                        <ArgonTypography variant="caption" color="white" fontWeight="medium">
                          {parent?.email || "N/A"}
                        </ArgonTypography>
                      </ArgonBox>
                    </ArgonBox>
                    {(parent?.address || parent?.generatedMapAddress) && (
                      <ArgonBox display="flex" flexDirection="column" gap={0.5}>
                        {parent?.address && (
                          <ArgonBox
                            sx={{
                              backgroundColor: "rgba(255,255,255,0.2)",
                              borderRadius: "8px",
                              padding: "4px 12px",
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              maxWidth: "600px",
                            }}
                          >
                            <ArgonTypography variant="caption" color="white" fontWeight="bold">
                              📍
                            </ArgonTypography>
                            <ArgonTypography variant="caption" color="white" fontWeight="medium">
                              {parent?.address}
                            </ArgonTypography>
                          </ArgonBox>
                        )}
                        {parent?.generatedMapAddress && (
                          <ArgonBox
                            sx={{
                              backgroundColor: "rgba(255,255,255,0.2)",
                              borderRadius: "8px",
                              padding: "4px 12px",
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              maxWidth: "600px",
                            }}
                          >
                            <ArgonTypography variant="caption" color="white" fontWeight="bold">
                              🗺️
                            </ArgonTypography>
                            <ArgonTypography
                              variant="caption"
                              color="white"
                              fontWeight="medium"
                              fontStyle="italic"
                            >
                              {parent?.generatedMapAddress}
                            </ArgonTypography>
                          </ArgonBox>
                        )}
                      </ArgonBox>
                    )}
                  </ArgonBox>
                </ArgonBox>
              </ArgonBox>

              {/* Joined Date Status */}
              <ArgonBox
                display="flex"
                alignItems="center"
                gap={1}
                sx={{
                  backgroundColor: "rgba(76, 175, 80, 0.2)",
                  padding: "8px 16px",
                  borderRadius: "20px",
                  border: "1px solid rgba(76, 175, 80, 0.5)",
                }}
              >
                <ArgonBox
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    backgroundColor: "#4caf50",
                  }}
                />
                <ArgonTypography variant="body2" fontWeight="medium" color="white">
                  Joined:{" "}
                  {parent?.createdAt ? new Date(parent.createdAt).toLocaleDateString() : "N/A"}
                </ArgonTypography>
              </ArgonBox>
            </ArgonBox>
          </Card>
        </Grid>
      </Grid>
      {/* Edit Profile Button */}
      <Box display="flex" gap={1} justifyContent="center" mt={2} mb={2} flexWrap="wrap">
        <ArgonButton
          onClick={handleEditOpen}
          variant="contained"
          startIcon={<PersonIcon />}
          color="primary"
          size="medium"
        >
          Edit Profile
        </ArgonButton>
        <ArgonButton
          onClick={handleStudentAddOpen}
          variant="contained"
          startIcon={<AddIcon />}
          color="success"
          size="medium"
        >
          Add Student
        </ArgonButton>
      </Box>
      <ArgonBox py={3}>
        <ArgonTypography variant="body1" fontWeight="medium" sx={{ px: 3 }} mb={2}>
          Student List
        </ArgonTypography>
        <ArgonBox
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          <Table columns={columns} rows={studentTableRows} />
        </ArgonBox>
      </ArgonBox>

      <Grid container spacing={3} mt={2}>
        {/* LEFT SIDE */}
        <Grid item xs={12} lg={8}>
          <ArgonTypography variant="body1" fontWeight="medium" sx={{ px: 2 }} mb={2}>
            Class Assigned to
          </ArgonTypography>

          <ArgonBox
            sx={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              boxShadow: "0 3px 12px rgba(0,0,0,0.06)",
              overflowX: "auto",
              "& .MuiTableRow-root:not(:last-child)": {
                "& td": {
                  borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                    `${borderWidth[1]} solid ${borderColor}`,
                },
              },
            }}
          >
            {classTableRows.length > 0 ? (
              <Table columns={classTableColumns} rows={classTableRows} />
            ) : (
              <ArgonBox p={3} textAlign="center">
                <ArgonTypography variant="body2" color="text" fontWeight="medium">
                  No classes assigned yet
                </ArgonTypography>
              </ArgonBox>
            )}
          </ArgonBox>
        </Grid>

        {/* RIGHT SIDE */}
        <Grid item xs={12} lg={4}>
          <ArgonBox
            mt={{ xs: 2, lg: 5 }}
            sx={{
              // background: "linear-gradient(135deg, #fbfcfcff 0%, #eceaeaff 100%)",
              borderRadius: "18px",
              border: "none",
              boxShadow: "0 6px 24px 0 rgba(0, 188, 212, 0.10)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Decorative background dots */}
            <ArgonBox
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                width: 200,
                height: 80,
                background: "radial-gradient(circle, #00bcd4 0%, transparent 70%)",
                opacity: 0.12,
                zIndex: 0,
              }}
            />
            <ArgonBox p={3} sx={{ position: "relative", zIndex: 1 }}>
              {/* Header Row */}
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <ArgonBox display="flex" alignItems="center" gap={1}>
                  <span style={{ fontSize: 28, marginRight: 6 }}>📝</span>
                  <ArgonTypography variant="h6" fontWeight="bold" color="primary">
                    Notes
                  </ArgonTypography>
                </ArgonBox>

                <ArgonButton
                  type="button"
                  onClick={handleOpenNoteDialog}
                  variant="contained"
                  size="small"
                  color="primary"
                  disabled={notesLoading}
                >
                  Add Note
                </ArgonButton>
              </ArgonBox>

              {/* Footer link */}
              <ArgonTypography
                variant="body2"
                color="secondary"
                sx={{
                  cursor: "pointer",
                  fontWeight: "bold",
                  letterSpacing: 0.5,
                  transition: "color 0.2s",
                  "&:hover": { color: "#2379f1ff" },
                }}
                onClick={handleOpenShowAllNotes}
              >
                Show All Notes →
              </ArgonTypography>
            </ArgonBox>
          </ArgonBox>
        </Grid>
      </Grid>

      {/* Notes Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px",
            padding: "8px",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #eee",
            pb: 1,
          }}
        >
          <ArgonTypography variant="h5" fontWeight="bold">
            Add Notes
          </ArgonTypography>
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          <ArgonBox mb={2}>
            <ArgonTypography variant="body2" fontWeight="medium" mb={1} color="text">
              Notes
            </ArgonTypography>
            <ArgonInput
              name="Notes"
              placeholder="Enter notes"
              multiline
              rows={4}
              fullWidth
              value={noteInput}
              onChange={(e) => setNoteInput(e.target.value)}
            />
          </ArgonBox>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <ArgonButton
            variant="outlined"
            color="secondary"
            onClick={handleClose}
            sx={{ borderRadius: "8px", textTransform: "none" }}
          >
            Cancel
          </ArgonButton>
          <ArgonButton
            type="button"
            variant="contained"
            color="primary"
            onClick={handleSaveNote}
            disabled={savingNote}
            sx={{ borderRadius: "8px", textTransform: "none" }}
          >
            {savingNote ? "Saving..." : "Save"}
          </ArgonButton>
        </DialogActions>
      </Dialog>

      {/* Show All Notes Dialog */}
      <Dialog
        open={showAllNotesOpen}
        onClose={handleCloseShowAllNotes}
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px",
            padding: "8px",
          },
        }}
      >
        <DialogTitle>All Notes</DialogTitle>
        <DialogContent>
          <ArgonBox py={2}>
            {notesLoading ? (
              <ArgonBox display="flex" justifyContent="center" py={4}>
                <CircularProgress size={24} />
              </ArgonBox>
            ) : parentNotes.length === 0 ? (
              <ArgonBox display="flex" flexDirection="column" alignItems="center" py={4}>
                <ArgonTypography variant="body2" color="text" mt={1}>
                  No notes available
                </ArgonTypography>
              </ArgonBox>
            ) : (
              <ArgonBox
                sx={{
                  "& .MuiTableRow-root:not(:last-child)": {
                    "& td": {
                      borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                        `${borderWidth[1]} solid ${borderColor}`,
                    },
                  },
                }}
              >
                <Table
                  columns={[
                    { name: "S.No.", align: "center" },
                    { name: "Date & Time", align: "center" },
                    { name: "Notes", align: "center" },
                  ]}
                  rows={parentNotes.map((entry, index) => {
                    const dateValue = entry?.createdAt ? new Date(entry.createdAt) : null;
                    const dateLabel =
                      dateValue && !Number.isNaN(dateValue.getTime())
                        ? dateValue.toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                        : "NA";

                    return {
                      "S.No.": (
                        <ArgonTypography variant="caption" color="text" fontWeight="medium">
                          {index + 1}
                        </ArgonTypography>
                      ),
                      "Date & Time": (
                        <ArgonTypography variant="caption" color="text" fontWeight="medium">
                          {dateLabel}
                        </ArgonTypography>
                      ),
                      Notes: (
                        <ArgonTypography variant="caption" color="text" fontWeight="medium">
                          {entry?.note || "NA"}
                        </ArgonTypography>
                      ),
                    };
                  })}
                />
              </ArgonBox>
            )}
          </ArgonBox>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <ArgonButton variant="outlined" color="secondary" onClick={handleCloseShowAllNotes}>
            Close
          </ArgonButton>
        </DialogActions>
      </Dialog>

      {/* Edit Profile Dialog */}
      {editOpen && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 600,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            {/* Header */}
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EditIcon sx={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      Edit Parent Profile
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Update parent information
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handleEditClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            {/* Form Content */}
            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <form onSubmit={handleUpdateParent}>
                <Grid container spacing={3}>
                  {/* Full Name */}
                  <Grid item xs={12}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Full Name
                    </ArgonTypography>
                    <ArgonInput
                      placeholder="Enter Full Name"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      fullWidth
                      size="medium"
                    />
                  </Grid>

                  {/* Email */}
                  <Grid item xs={12}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Email Address
                    </ArgonTypography>
                    <ArgonInput
                      placeholder="Enter Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      fullWidth
                      size="medium"
                    />
                  </Grid>

                  {/* Phone */}
                  <Grid item xs={12}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Mobile Number
                    </ArgonTypography>
                    <ArgonInput
                      placeholder="Enter mobile number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      fullWidth
                      size="medium"
                      type="number"
                    />
                  </Grid>

                  {/* Alternate Phone */}
                  <Grid item xs={12}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Alternate Mobile Number
                    </ArgonTypography>
                    <ArgonInput
                      placeholder="Enter alternate mobile number"
                      value={alternatePhone}
                      onChange={(e) => setAlternatePhone(e.target.value)}
                      fullWidth
                      size="medium"
                      type="number"
                    />
                  </Grid>

                  {/* Address */}
                  <Grid item xs={12}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Address
                    </ArgonTypography>
                    <ArgonInput
                      placeholder="Enter address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      fullWidth
                      size="medium"
                      multiline
                      rows={2}
                    />
                  </Grid>

                  {/* Profile Image */}
                  <Grid item xs={12}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Profile Image
                    </ArgonTypography>
                    {profileImagePreview && (
                      <ArgonBox mb={2}>
                        <ArgonTypography variant="caption" color="text" mb={1}>
                          Current Image:
                        </ArgonTypography>
                        <ArgonBox>
                          <img
                            src={profileImagePreview}
                            alt="Profile"
                            height="80px"
                            width="80px"
                            style={{
                              border: "1px solid #e0e7ff",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                          />
                        </ArgonBox>
                      </ArgonBox>
                    )}
                    <FileUploader
                      label="Upload New Profile Image"
                      files={profileImageFiles}
                      setFiles={setProfileImageFiles}
                      accept="image/*"
                      multiple={false}
                      Width="100%"
                      Height={120}
                    />
                  </Grid>

                  {/* Action Buttons */}
                  <Grid item xs={12}>
                    <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={2}>
                      <ArgonButton
                        variant="outlined"
                        color="secondary"
                        onClick={handleEditClose}
                        disabled={updating}
                      >
                        Cancel
                      </ArgonButton>
                      <ArgonButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={updating}
                        startIcon={updating && <CircularProgress size={16} color="inherit" />}
                      >
                        {updating ? "Updating..." : "Update Profile"}
                      </ArgonButton>
                    </ArgonBox>
                  </Grid>
                </Grid>
              </form>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Image Modal */}
      <Dialog
        open={imageModalOpen}
        onClose={() => setImageModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {parent?.fullName || "Parent Image"}
          <IconButton
            onClick={() => setImageModalOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <ArgonBox display="flex" justifyContent="center">
            <img
              src={selectedImage}
              alt={parent?.fullName || "Parent Image"}
              style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
            />
          </ArgonBox>
        </DialogContent>
      </Dialog>

      {/* Add/Edit Student Dialog */}
      {(studentAddOpen || (studentEditOpen && selectedStudent)) && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 600,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            {/* Header */}
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EditIcon sx={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      {studentAddOpen ? "Add Student" : "Edit Student Details"}
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      {studentAddOpen
                        ? "Create student under this parent"
                        : "Update student information"}
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={studentAddOpen ? handleStudentAddClose : handleStudentEditClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            {/* Form Content */}
            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <form onSubmit={studentAddOpen ? handleCreateStudent : handleUpdateStudent}>
                <Grid container spacing={3}>
                  {/* Student Name */}
                  <Grid item xs={12}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Student Name
                    </ArgonTypography>
                    <ArgonInput
                      placeholder="Enter Student Name"
                      value={studentName}
                      onChange={(e) => setStudentName(e.target.value)}
                      fullWidth
                      size="medium"
                    />
                  </Grid>

                  {/* Gender */}
                  <Grid item xs={12} sm={6}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Gender *
                    </ArgonTypography>
                    <Dropdown
                      value={studentGender}
                      options={[
                        { label: "Select Gender", value: "" },
                        { label: "Male", value: "MALE" },
                        { label: "Female", value: "FEMALE" },
                        { label: "Other", value: "OTHER" },
                      ]}
                      onChange={(e) => setStudentGender(e.target.value)}
                      width="100%"
                      size="medium"
                    />
                  </Grid>

                  {/* Date of Birth */}
                  <Grid item xs={12} sm={6}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Date of Birth
                    </ArgonTypography>
                    <ArgonInput
                      type="date"
                      value={studentDob}
                      onChange={(e) => setStudentDob(e.target.value)}
                      fullWidth
                      size="medium"
                    />
                  </Grid>

                  {/* School Name */}
                  <Grid item xs={12}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      School/College/University Name
                    </ArgonTypography>
                    <ArgonInput
                      placeholder="Enter School Name"
                      value={studentSchoolName}
                      onChange={(e) => setStudentSchoolName(e.target.value)}
                      fullWidth
                      size="medium"
                    />
                  </Grid>

                  {/* Class */}
                  <Grid item xs={12} sm={6}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Class
                    </ArgonTypography>
                    <Dropdown
                      value={studentClass}
                      options={[
                        { label: "Select Class", value: "" },
                        ...allClasses.map((cls) => ({ label: cls.label, value: cls.value })),
                      ]}
                      onChange={(e) => setStudentClass(e.target.value)}
                      width="100%"
                      size="medium"
                    />
                  </Grid>

                  {/* Board */}
                  <Grid item xs={12} sm={6}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Board
                    </ArgonTypography>
                    <Dropdown
                      value={studentBoard}
                      options={[
                        { label: "Select Board", value: "" },
                        ...allBoards.map((board) => ({ label: board.label, value: board.value })),
                      ]}
                      onChange={(e) => setStudentBoard(e.target.value)}
                      width="100%"
                      size="medium"
                    />
                  </Grid>

                  {/* Subjects (Multi-select) */}
                  <Grid item xs={12}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Subjects
                    </ArgonTypography>
                    <Autocomplete
                      disablePortal
                      multiple
                      disableCloseOnSelect
                      options={allSubjects}
                      value={allSubjects.filter((subject) =>
                        studentSubjects.includes(subject.value)
                      )}
                      onChange={(event, newValue) => {
                        setStudentSubjects(newValue.map((subject) => subject.value));
                      }}
                      getOptionLabel={(option) => option.label || ""}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select subjects"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              minHeight: "45px",
                              border: "1px solid #d2d6da",
                              borderRadius: "8px",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "none",
                            },
                          }}
                        />
                      )}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip
                            {...getTagProps({ index })}
                            key={option.value}
                            label={option.label}
                            deleteIcon={<CancelIcon />}
                            sx={{
                              backgroundColor: "#667eea",
                              color: "white",
                              "& .MuiChip-deleteIcon": {
                                color: "white",
                                "&:hover": {
                                  color: "rgba(255,255,255,0.7)",
                                },
                              },
                            }}
                          />
                        ))
                      }
                    />
                  </Grid>

                  {/* Preferred Time Duration */}
                  <Grid item xs={12} sm={6}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Preferred Time Duration (mins)
                    </ArgonTypography>
                    <ArgonInput
                      placeholder="Enter duration in minutes"
                      value={studentPreferredTime}
                      onChange={(e) => setStudentPreferredTime(e.target.value)}
                      fullWidth
                      size="medium"
                      type="number"
                    />
                  </Grid>

                  {/* Classes Per Week */}
                  <Grid item xs={12} sm={6}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Classes Per Week
                    </ArgonTypography>
                    <ArgonInput
                      placeholder="Enter classes per week"
                      value={studentClassesPerWeek}
                      onChange={(e) => setStudentClassesPerWeek(e.target.value)}
                      fullWidth
                      size="medium"
                      type="number"
                    />
                  </Grid>

                  {/* Mode of Tuition */}
                  <Grid item xs={12}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Mode of Tuition *
                    </ArgonTypography>
                    <Dropdown
                      value={studentModeOfTuition}
                      options={[
                        { label: "Select Mode of Tuition", value: "" },
                        { label: "Online", value: "ONLINE" },
                        { label: "Offline", value: "OFFLINE" },
                        { label: "Both", value: "BOTH" },
                      ]}
                      onChange={(e) => setStudentModeOfTuition(e.target.value)}
                      width="100%"
                      size="medium"
                    />
                  </Grid>

                  {/* Tuition Preferred Location */}
                  <Grid item xs={12}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Tuition Preferred Location
                    </ArgonTypography>
                    <Dropdown
                      value={studentTuitionPreferredLocation}
                      options={[
                        { label: "Select Tuition Preferred Location", value: "" },
                        { label: "Home", value: "HOME" },
                        {
                          label: "Offline Tuition Institute",
                          value: "OFFLINE_TUITION_INSTITUTE",
                        },
                      ]}
                      onChange={(e) => setStudentTuitionPreferredLocation(e.target.value)}
                      width="100%"
                      size="medium"
                    />
                  </Grid>
                  {/* Action Buttons */}
                  <Grid item xs={12}>
                    <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={2}>
                      <ArgonButton
                        variant="outlined"
                        color="secondary"
                        onClick={studentAddOpen ? handleStudentAddClose : handleStudentEditClose}
                        disabled={creatingStudent || updatingStudent}
                      >
                        Cancel
                      </ArgonButton>
                      <ArgonButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={creatingStudent || updatingStudent}
                        startIcon={
                          (creatingStudent || updatingStudent) && (
                            <CircularProgress size={16} color="inherit" />
                          )
                        }
                      >
                        {studentAddOpen
                          ? creatingStudent
                            ? "Adding..."
                            : "Add Student"
                          : updatingStudent
                          ? "Updating..."
                          : "Update Student"}
                      </ArgonButton>
                    </ArgonBox>
                  </Grid>
                </Grid>
              </form>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Delete Student Confirmation Dialog */}
      <DeleteDialog
        open={deleteDialogOpen}
        onClose={handleStudentDeleteClose}
        onConfirm={handleStudentDeleteConfirm}
        title="Delete Student"
        description={`Are you sure you want to delete ${
          studentToDelete?.name || "this student"
        }? This action cannot be undone.`}
        confirmText="Delete Student"
        cancelText="Cancel"
      />
    </ArgonBox>
  );
}

export default profile;
